import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=f1b2d512&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports